import { render, staticRenderFns } from "./CODInfo.vue?vue&type=template&id=347dccac&scoped=true&"
import script from "./CODInfo.vue?vue&type=script&lang=js&"
export * from "./CODInfo.vue?vue&type=script&lang=js&"
import style0 from "./CODInfo.vue?vue&type=style&index=0&id=347dccac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347dccac",
  null
  
)

export default component.exports